export default __webpack_public_path__ + "static/media/675.68654881.jpg";